var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "distribution pad30" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("推荐返利")]),
      _c("div", { staticClass: "mar20-tb flex" }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-column h120 justify-center pad50-lr border-r"
          },
          [
            _c("div", { staticClass: "f36 mar10-b text-left" }, [
              _vm._v(_vm._s(_vm.info.recommendRewardNum || 0))
            ]),
            _c("div", { staticClass: "f14" }, [
              _c("span", { staticClass: "gray6" }, [
                _vm._v("累计收益（积分）")
              ]),
              _c(
                "span",
                {
                  staticClass: "red mar10-l pointer",
                  on: { click: _vm.openHome }
                },
                [_vm._v("积分明细")]
              )
            ])
          ]
        ),
        _c("div", { staticClass: "flex flex-auto" }, [
          _c(
            "div",
            { staticClass: "flex flex-column h120 justify-center pad50-l" },
            [
              _c("div", { staticClass: "f30 lin-36 mar10-b text-left" }, [
                _vm._v(_vm._s(_vm.info.todayPointNum || 0))
              ]),
              _c("div", { staticClass: "f14 gray6" }, [
                _vm._v("今日预估（积分）")
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "flex flex-column h120 justify-center pad50-l" },
            [
              _c("div", { staticClass: "f30 lin-36 mar10-b text-left" }, [
                _vm._v(_vm._s(_vm.info.weekPointNum || 0))
              ]),
              _c("div", { staticClass: "f14 gray6" }, [
                _vm._v("本周预估（积分）")
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "flex flex-column h120 justify-center pad50-l" },
            [
              _c("div", { staticClass: "f30 lin-36 mar10-b text-left" }, [
                _vm._v(_vm._s(_vm.info.monthPointNum || 0))
              ]),
              _c("div", { staticClass: "f14 gray6" }, [
                _vm._v("本月预估（积分）")
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "flex flex-column h120 justify-center pad50-l" },
            [
              _c("div", { staticClass: "f30 lin-36 mar10-b text-left" }, [
                _vm._v(_vm._s(_vm.info.yearPointNum || 0))
              ]),
              _c("div", { staticClass: "f14 gray6" }, [
                _vm._v("本年预估（积分）")
              ])
            ]
          )
        ])
      ]),
      _c("div", { staticClass: "bg-f5 lin-20 pad10-tb pad20-lr mar20-b" }, [
        _vm._v(
          "\n    温馨提示：推荐返利积分是由您推荐的客户（旗舰店设置关系后）在农信数智官方旗舰店进行交易后，店铺返还给您的奖励，该积分在客户确认收货（交易完成）后自动发放，您可在积分所属的店铺进行采购抵扣货款。\n  "
        )
      ]),
      _c(
        "div",
        { staticClass: "flex items-center mar20-b" },
        [
          _c("div", [_vm._v("时间：")]),
          _c("el-date-picker", {
            staticClass: "mar20_r",
            attrs: {
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期"
            },
            model: {
              value: _vm.timeList,
              callback: function($$v) {
                _vm.timeList = $$v
              },
              expression: "timeList"
            }
          }),
          _c("div", [_vm._v("订单状态：")]),
          _c(
            "el-select",
            {
              staticClass: "w240 mar20_r",
              attrs: { placeholder: "请选择订单状态" },
              model: {
                value: _vm.search.orderStatus,
                callback: function($$v) {
                  _vm.$set(_vm.search, "orderStatus", $$v)
                },
                expression: "search.orderStatus"
              }
            },
            _vm._l(_vm.statusList, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchList } },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex items-center text-center bg-f5 h40 mar10-b" },
        [
          _c("div", { staticClass: "flex-auto" }, [_vm._v("货品信息")]),
          _c("div", { staticClass: "w200" }, [_vm._v("订单金额")]),
          _c(
            "div",
            { staticClass: "w200" },
            [
              _c("span", [_vm._v("返利积分")]),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content:
                      "返利总额为预估返利，实际返利积分以客户确认收货后为准",
                    placement: "top"
                  }
                },
                [_c("i", { staticClass: "el-icon-question pointer" })]
              )
            ],
            1
          ),
          _c("div", { staticClass: "w200" }, [_vm._v("订单状态")])
        ]
      ),
      _vm.list.length
        ? [
            _vm._l(_vm.list, function(item) {
              return _c("div", { key: item.id, staticClass: "bor-gray" }, [
                _c("div", { staticClass: "bg-f5 h30 flex items-center" }, [
                  _c("span", { staticClass: "pad10-lr" }, [
                    _vm._v("订单编号：" + _vm._s(item.orderId))
                  ]),
                  _c("span", { staticClass: "pad10-lr" }, [
                    _vm._v("买家：" + _vm._s(item.userName))
                  ])
                ]),
                _c("div", { staticClass: "flex pad10-tb" }, [
                  _c(
                    "div",
                    { staticClass: "flex-auto" },
                    _vm._l(item.orderGoodsInfoList, function(good, index) {
                      return _c("div", { key: index, staticClass: "flex" }, [
                        _c("div", { staticClass: "flex flex-auto pad20-l" }, [
                          _c("img", {
                            staticClass: "good-img",
                            attrs: { src: good.goodsPic }
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-column justify-between pad10-l"
                            },
                            [
                              _c("div", [_vm._v(_vm._s(good.goodsName))]),
                              _c("div", [
                                _vm._v("规格：" + _vm._s(good.goodsSpec))
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "w180 flex items-center justify-end"
                            },
                            [_vm._v("x" + _vm._s(good.quantity))]
                          )
                        ])
                      ])
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "w200 flex items-center justify-center" },
                    [_vm._v("￥" + _vm._s(item.fMoney))]
                  ),
                  _c(
                    "div",
                    { staticClass: "w200 flex items-center justify-center" },
                    [_vm._v(_vm._s(item.pointsNum))]
                  ),
                  _c(
                    "div",
                    { staticClass: "w200 flex items-center justify-center" },
                    [_vm._v(_vm._s(item.orderStatus))]
                  )
                ])
              ])
            }),
            _c(
              "div",
              { staticClass: "flex items-center mar40-t" },
              [
                _c("div", { staticClass: "gray9 flex-auto" }, [
                  _vm._v(
                    "共 " +
                      _vm._s(_vm.pageTotal) +
                      " 条记录 第 " +
                      _vm._s(_vm.pageNum) +
                      " / " +
                      _vm._s(_vm.totalPage) +
                      " 页"
                  )
                ]),
                _c("el-pagination", {
                  attrs: {
                    layout: "prev, pager, next, sizes, jumper",
                    background: "",
                    "hide-on-single-page": "",
                    "page-size": _vm.pageSize,
                    "page-count": _vm.totalPage,
                    "current-page": _vm.pageNum,
                    "page-sizes": [10, 50, 100]
                  },
                  on: {
                    "update:pageSize": function($event) {
                      _vm.pageSize = $event
                    },
                    "update:page-size": function($event) {
                      _vm.pageSize = $event
                    },
                    "update:currentPage": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:current-page": function($event) {
                      _vm.pageNum = $event
                    },
                    "size-change": _vm.sizeChange,
                    "current-change": _vm.currentChange
                  }
                })
              ],
              1
            )
          ]
        : _c(
            "div",
            {
              staticClass: "pad30-tb bor-gray flex items-center justify-center"
            },
            [_vm._v("暂无订单")]
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }